export const getEnvironmentType = () =>
  window.ENV_CONFIG['rpa-pod-ui'].environmentType;

export const getApiUrl = () => window.ENV_CONFIG['rpa-pod-ui'].rpaApiUrl;

export const getPendoKey = () => window.ENV_CONFIG['rpa-pod-ui'].pendoKey;
